class Logger {
    log() {
        console.log(...arguments);
    }
}

window.__logger = new Logger();
window.__log = window.__logger.log;